import React from 'react';
import { FilledButton, FlexColumn, SvgIcon } from '@make-software/tg-mini-app-ui';

import EmptyProjectsIcon from '@/shared/assets/icons/illustration-home.svg';
import { openLink } from '@/utils';

import { EmptyProjectSubtitle, EmptyProjectTitle } from './styled';

export const EmptyProjects: React.FC = () => {
  return (
    <FlexColumn
      justify="center"
      align="center"
      style={{ alignSelf: 'center', marginTop: 20 }}
      gap={10}
    >
      <SvgIcon src={EmptyProjectsIcon} size={250} />
      <EmptyProjectTitle weight={3}>Projects are coming</EmptyProjectTitle>
      <EmptyProjectSubtitle weight={3}>
        Participate in the hackathon submitting your project idea on the DoraHacks website
      </EmptyProjectSubtitle>
      <FilledButton
        title="Open DoraHacks"
        onClick={openLink(window.config.dorahacks_hackathon_url)}
        fontWeight={500}
      />
    </FlexColumn>
  );
};
